import { render, staticRenderFns } from "./TrainingVideos.vue?vue&type=template&id=4c8085f9&scoped=true"
import script from "./TrainingVideos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrainingVideos.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrainingVideos.vue?vue&type=style&index=0&id=4c8085f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8085f9",
  null
  
)

export default component.exports